import { FileIcon } from "@phosphor-icons/react";

import { CodeEditorLanguage } from "@gx/dls/editor/CodeEditor";
import Icon from "@gx/dls/icons/Icon";
import { SelectInputOption } from "@gx/dls/inputs/SelectInput";
import {
  SourceArtifactContentType,
  SourceArtifactType,
} from "@gx/ts-contracts/services/database/models/public_pb";

const SOURCE_ARTIFACT_CONTENT_TYPE_TTL_LABEL = "Turtle";
const SOURCE_ARTIFACT_CONTENT_TYPE_TTL_FILE_EXTENSION = "ttl";
const SOURCE_ARTIFACT_CONTENT_TYPE_JSON_LABEL = "JSON";
const SOURCE_ARTIFACT_CONTENT_TYPE_JSON_FILE_EXTENSION = "json";
const SOURCE_ARTIFACT_CONTENT_TYPE_MD_LABEL = "Markdown";
const SOURCE_ARTIFACT_CONTENT_TYPE_MD_FILE_EXTENSION = "md";

export const SOURCE_ARTIFACT_CONTENT_TYPE_TO_NAME_MAP: Record<SourceArtifactContentType, string> = {
  [SourceArtifactContentType.UNSPECIFIED]: "—",
  [SourceArtifactContentType.TTL]: SOURCE_ARTIFACT_CONTENT_TYPE_TTL_LABEL,
  [SourceArtifactContentType.JSON]: SOURCE_ARTIFACT_CONTENT_TYPE_JSON_LABEL,
  [SourceArtifactContentType.MD]: SOURCE_ARTIFACT_CONTENT_TYPE_MD_LABEL,
};

export const SOURCE_ARTIFACT_CONTENT_TYPE_TO_FILE_EXTENSION_MAP: Record<
  SourceArtifactContentType,
  string
> = {
  [SourceArtifactContentType.UNSPECIFIED]: "—",
  [SourceArtifactContentType.TTL]: SOURCE_ARTIFACT_CONTENT_TYPE_TTL_FILE_EXTENSION,
  [SourceArtifactContentType.JSON]: SOURCE_ARTIFACT_CONTENT_TYPE_JSON_FILE_EXTENSION,
  [SourceArtifactContentType.MD]: SOURCE_ARTIFACT_CONTENT_TYPE_MD_FILE_EXTENSION,
};

export const SOURCE_ARTIFACT_CONTENT_TYPE_TO_CODE_EDITOR_LANGUAGE_MAP: Record<
  SourceArtifactContentType,
  CodeEditorLanguage
> = {
  [SourceArtifactContentType.UNSPECIFIED]: "text",
  [SourceArtifactContentType.TTL]: SOURCE_ARTIFACT_CONTENT_TYPE_TTL_FILE_EXTENSION,
  [SourceArtifactContentType.JSON]: SOURCE_ARTIFACT_CONTENT_TYPE_JSON_FILE_EXTENSION,
  [SourceArtifactContentType.MD]: SOURCE_ARTIFACT_CONTENT_TYPE_MD_FILE_EXTENSION,
};

const SOURCE_ARTIFACT_TYPE_TABLE_RESEARCH_LABEL = "Table Research";
const SOURCE_ARTIFACT_TYPE_SOURCE_RESEARCH_LABEL = "Source Research";
const SOURCE_ARTIFACT_TYPE_SOURCE_SKOS_LABEL = "SKOS Model";
const SOURCE_ARTIFACT_TYPE_SOURCE_SHACL_LABEL = "SHACL Model";
const SOURCE_ARTIFACT_TYPE_SOURCE_MANIFEST_LABEL = "Manifest";
const SOURCE_ARTIFACT_TYPE_SOURCE_SCHEMA_REGISTRY_LABEL = "Schema Registry";

export const SOURCE_ARTIFACT_TYPE_TO_NAME_MAP: Record<SourceArtifactType, string> = {
  [SourceArtifactType.UNSPECIFIED]: "—",
  [SourceArtifactType.TABLE_RESEARCH]: SOURCE_ARTIFACT_TYPE_TABLE_RESEARCH_LABEL,
  [SourceArtifactType.SOURCE_RESEARCH]: SOURCE_ARTIFACT_TYPE_SOURCE_RESEARCH_LABEL,
  [SourceArtifactType.SOURCE_SKOS]: SOURCE_ARTIFACT_TYPE_SOURCE_SKOS_LABEL,
  [SourceArtifactType.SOURCE_SHACL]: SOURCE_ARTIFACT_TYPE_SOURCE_SHACL_LABEL,
  [SourceArtifactType.SOURCE_MANIFEST]: SOURCE_ARTIFACT_TYPE_SOURCE_MANIFEST_LABEL,
  [SourceArtifactType.SOURCE_SCHEMA_REGISTRY]: SOURCE_ARTIFACT_TYPE_SOURCE_SCHEMA_REGISTRY_LABEL,
};

export const SOURCE_ARTIFACT_TYPE_MULTI_SELECT_OPTIONS: SelectInputOption[] = [
  {
    id: SourceArtifactType.TABLE_RESEARCH.toString(),
    label: SOURCE_ARTIFACT_TYPE_TABLE_RESEARCH_LABEL,
    value: SourceArtifactType.TABLE_RESEARCH,
  },
  {
    id: SourceArtifactType.SOURCE_RESEARCH.toString(),
    label: SOURCE_ARTIFACT_TYPE_SOURCE_RESEARCH_LABEL,
    value: SourceArtifactType.SOURCE_RESEARCH,
  },
  {
    id: SourceArtifactType.SOURCE_SKOS.toString(),
    label: SOURCE_ARTIFACT_TYPE_SOURCE_SKOS_LABEL,
    value: SourceArtifactType.SOURCE_SKOS,
  },
  {
    id: SourceArtifactType.SOURCE_SHACL.toString(),
    label: SOURCE_ARTIFACT_TYPE_SOURCE_SHACL_LABEL,
    value: SourceArtifactType.SOURCE_SHACL,
  },
  {
    id: SourceArtifactType.SOURCE_MANIFEST.toString(),
    label: SOURCE_ARTIFACT_TYPE_SOURCE_MANIFEST_LABEL,
    value: SourceArtifactType.SOURCE_MANIFEST,
  },
  {
    id: SourceArtifactType.SOURCE_SCHEMA_REGISTRY.toString(),
    label: SOURCE_ARTIFACT_TYPE_SOURCE_SCHEMA_REGISTRY_LABEL,
    value: SourceArtifactType.SOURCE_SCHEMA_REGISTRY,
  },
];

export const SOURCE_ARTIFACT_CONTENT_TYPE_MULTI_SELECT_OPTIONS: SelectInputOption[] = [
  {
    id: SourceArtifactContentType.TTL.toString(),
    label: SOURCE_ARTIFACT_CONTENT_TYPE_TTL_LABEL,
    value: SourceArtifactContentType.TTL,
  },
  {
    id: SourceArtifactContentType.JSON.toString(),
    label: SOURCE_ARTIFACT_CONTENT_TYPE_JSON_LABEL,
    value: SourceArtifactContentType.JSON,
  },
  {
    id: SourceArtifactContentType.MD.toString(),
    label: SOURCE_ARTIFACT_CONTENT_TYPE_MD_LABEL,
    value: SourceArtifactContentType.MD,
  },
];

export const SOURCE_ARTIFACT_CONTENT_TYPE_TO_ICON_MAP: Record<
  SourceArtifactContentType,
  React.ReactNode
> = {
  [SourceArtifactContentType.UNSPECIFIED]: "—",
  [SourceArtifactContentType.TTL]: <Icon component={FileIcon} />,
  [SourceArtifactContentType.JSON]: <Icon component={FileIcon} />,
  [SourceArtifactContentType.MD]: <Icon component={FileIcon} />,
};
